import { Mark } from "@tiptap/core";

export const SuperscriptMark = Mark.create({
    name: "superscript",

    parseHTML() {
        return [{ tag: "sup" }];
    },

    renderHTML() {
        return ["sup", 0];
    },

    addCommands() {
        return {
        toggleSuperscript:
            () =>
                ({ commands }) => {
                    return commands.toggleMark("superscript");
                },
        };
    },

    addKeyboardShortcuts() {
        return {
            "Mod-.": () => this.editor.commands.toggleSuperscript(),
        };
    },
});
